import { API } from './API'

const DEFAULT_OPTIONS = {
    baseUrl: 'recaptcha'
}

export class RecaptchaAPI extends API {
    constructor(options = {}) {
        super({ ...DEFAULT_OPTIONS, ...options })
    }

    async validateRecaptcha(recaptchaToken) {
        const params = [recaptchaToken]
        return super.get({ params })
    }
}
